export default {
    technologyCategories:{
        0:'All',
        1:'Frontend',
        2:'Backend',
        3:'Languages',
        4:'Tools',
        5:'Favorites'
    },
    technologies:[
            {
                imgSrc: require('@/assets/images/technologies/html.png'), 
                name:'HTML',
                text:'',
                class:'',
                category:[1]
            },
            {
                imgSrc: require('@/assets/images/technologies/css.png'), 
                name:'CSS',
                text:'',
                class:'',
                category:[1]
            },
            {
                imgSrc: require('@/assets/images/technologies/js.png'), 
                name:'Javascript',
                text:'',
                class:'',
                category:[1,3,5]
            },
            {
                imgSrc:'https://avatars1.githubusercontent.com/u/1562726?v=3&s=400', 
                name:'D3.js',
                text:'Bring data to life. Limited only by your imagination.',
                class:'',
                category:[1,5]
            },
            {
                imgSrc:'https://vuejs.org/images/logo.png', 
                name:'Vue.js',
                text:'Simple.<br>Expressive.<br>Fun!',
                class:'',
                category:[1,5]
            },
            {
                imgSrc: require('@/assets/images/technologies/lodash.png'), 
                name:'Lodash.js',
                text:'Without this... I am nothing',
                class:'',
                category:[1]
            },
            {
                imgSrc:'https://www.codeforest.net/wp-content/uploads/2013/05/backbone.png', 
                name:'Backbone.js',
                text:'My first javascript framework',
                class:'',
                category:[1]
            },
            {
                imgSrc: require('@/assets/images/technologies/java.png'), 
                name:'Java',
                text:'Same thing as Javascript, right?',
                class:'',
                category:[3]
            },
            {
                imgSrc: require('@/assets/images/technologies/sass.png'), 
                name:'Sass/Scss',
                text:'',
                class:'',
                category:[4]
            },
            {
                imgSrc: require('@/assets/images/technologies/leaflet.jpg'), 
                name:'Leaflet.js',
                text:'Makes mapping a breeze',
                class:'',
                category:[1]
            },
            {
                imgSrc: require('@/assets/images/technologies/grunt.png'), 
                name:'Grunt',
                text:'My first build tool',
                class:'',
                category:[4]
            },
            {
                imgSrc: require('@/assets/images/technologies/webpack.jpg'), 
                name:'Webpack',
                text:"How does it even work?",
                class:'',
                category:[4]
            },
            {
                imgSrc: require('@/assets/images/technologies/npm.png'), 
                name:'npm',
                text:'Welcome to dependency hell',
                class:'',
                category:[4]
            },
            {
                imgSrc: require('@/assets/images/technologies/git.png'), 
                name:'git',
                text:'SAVE YOUR WORK!!!',
                class:'',
                category:[4]
            },
            {
                imgSrc:require('@/assets/images/technologies/socketio.gif'), 
                name:'Socket.IO',
                text:'',
                class:'',
                category:[1,2]
            },
            {
                imgSrc: require('@/assets/images/technologies/sql-server.png'), 
                name:'SQL Server',
                class:'',
                category:[2,3]
            },
            {
                imgSrc: require('@/assets/images/robot.svg'), 
                name:'Egg',
                text:'A somewhat reliable robot butler.',
                class:'',
                category:[5]
            },
            {
                imgSrc: require('@/assets/images/technologies/tomcat.png'), 
                name:'Apache Tomcat',
                text:'I have 2 cats',
                class:'',
                category:[2]
            },
            {
                imgSrc: require('@/assets/images/technologies/node.png'), 
                name:'Node.js',
                text:'',
                class:'',
                category:[2]
            },
            {
                imgSrc: require('@/assets/images/technologies/nginx.png'), 
                name:'nginx',
                text:'',
                class:'',
                category:[2]
            },
            {
                imgSrc: require('@/assets/images/technologies/firebase.png'), 
                name:'Firebase',
                text:'',
                class:'',
                category:[2]
            },
            {
                imgSrc: require('@/assets/images/technologies/mocha.svg'), 
                name:'Mocha',
                text:'',
                class:'',
                category:[4]
            },
            {
                imgSrc: require('@/assets/images/technologies/chai.png'), 
                name:'Chai',
                text:'Testing.is.fun<br>.with.chai',
                class:'',
                category:[4]
            },
            {
                imgSrc: 'https://cdn.worldvectorlogo.com/logos/react.svg', 
                name:'React',
                text:'',
                class:'',
                category:[1,5]
            },
            {
                imgSrc: require('@/assets/images/technologies/redux.png'), 
                name:'Redux',
                text:'It\'s not magic (somewhat condescendingly)',
                class:'',
                category:[1,5]
            },
			
    ],
}